export default __webpack_public_path__ + "static/media/notion_icon.6b2e7308.svg";